<template>
  <v-app class="position-relative">
    <div class="d-md-flex d-block login-form-wrapper" style="width: 100%">
      <div class="position-fixed top-0 left-0 w-100 h-100" style="z-index: 1; top: 0; left: 0;">
        <div id="login-slider-wrapper">
          <div id="promotion-login-slider">
            <div>
              <div
                class="image-slide position-fixed"
                :style="`background-image: url('/static/image/slider/${randomBackground}.jpg')`"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        class="
          imagesContainer
          d-none d-md-flex
          align-content-center align-items-center
          justify-content-center
          w-50
        "
      >
        <div
          style="width: 90%; max-width: 100%; position: relative; z-index: 99"
        >
          <div class="d-flex flex-column p-4" style="color: white">
            <div
              class="d-flex flex-column align-items-center"
              style="font-size: 1.5rem"
            >
              <img
                src="/logo/Gpuhub-logo-text-white.svg"
                style="height: 3.5rem"
              />
              <div style="font-size: 1rem; font-style: italic" class="mt-2">
                <img src="/logo/happy-rendering.svg" style="height: 24px;">
              </div>
            </div>
            <div class="mt-3 d-flex justify-content-center">
              <div style="font-size: 1rem; font-weight: 600">
                We bring the power of thousands of friendly and easy-to-use GPUs
                directly to your desk
              </div>
            </div>
            <div
              v-if="change"
              style="text-align: center; font-size: 0.9rem"
              class="mb-1 mt-1"
            >
              The advent of cloud computing (GPU & CPU Cloud ) and open horizons
              in the world of Big Data, AI and high performance 3D Rendering
              have created demand on using reliable GPU Cloud power at a price
              that's cheap enough for every field, every human needs it. That's
              the reason why we're here, iRender-GPU Cloud. We bring the power
              of thousands of friendly and easy-to-use GPUs directly to your
              desk.
            </div>
            <div
              v-else
              style="text-align: center; font-size: 0.9rem"
              class="mb-1 mt-1"
            >
              Reduce your operating system load and speed up your computer by
              moving workload to Build & Train & Tune the model of your AI/ Deep
              Learning project onto GPU Cloud. With only 5 clicks to get access
              to a world class GPU computing. Fully-managed enterprise GPU cloud
              platform. Desktops, terminals, and servers. Enjoy freedom and take
              advantage of easy and cost effective scaling up the hardware
              infrastructure from your own workstation. Let’s work together and
              “Happy Training”.
            </div>
          </div>
          <div class="d-flex flex-nowrap mt-10">
            <div class="w-50 mr-1 video-item">
              <div
                style="
                  width: 100%;
                  max-width: 100%;
                  padding-top: 50%;
                  position: relative;
                "
              >
                <iframe
                  src="https://www.youtube.com/embed/6S6L4-hzWBQ"
                  frameborder="0"
                  style="
                    z-index: 99;
                    border-radius: 5px;
                    position: absolute;
                    margin: auto;
                    width: 100%;
                    height: 100%;
                    top: 0;
                    left: 0;
                  "
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
            <div class="w-50 ml-1 video-item">
              <div
                style="
                  width: 100%;
                  max-width: 100%;
                  padding-top: 50%;
                  position: relative;
                "
              >
                <iframe
                  src="https://www.youtube.com/embed/IjsoT7jeH14"
                  frameborder="0"
                  style="
                    z-index: 99;
                    border-radius: 5px;
                    position: absolute;
                    margin: auto;
                    width: 100%;
                    height: 100%;
                    top: 0;
                    left: 0;
                  "
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="
          flex-fill
          d-flex
          align-content-center
          justify-content-center
          align-items-center
          position-relative
        "
        style="z-index: 100"
      >
        <component
          v-bind:is="mainComponent"
          @openComponentView="openComponentView"
          :location="location"
        />
      </div>
    </div>
  </v-app>
</template>

<script>
import baseComponent from "@/scripts/baseComponent";
import lazyLoadComponent from "@/scripts/lazyLoadComponent";
import SkeletonBox from "@/views/component/SkeletonBox";
import "bxslider/dist/jquery.bxslider.css";
import "bxslider/dist/jquery.bxslider.min.js";
import "@/assets/css/login.scss";
import "@/assets/responsive/login.scss";
import authApi from "@/api/auth";
const queryString = require("query-string");
const minBgIndex = 1;
const maxBgIndex = 4;
export default {
  extends: baseComponent,
  components: {},
  props: {},
  data: () => ({
    mainComponent: lazyLoadComponent({
      componentFactory: () => import("@/views/auth/component/Login"),
      loading: SkeletonBox,
    }),
    change: false,
    location: "",
  }),
  computed:{
    randomBackground() {
      let rndInt = Math.floor(Math.random() * maxBgIndex) + minBgIndex;
      try{
        let lastRandom = localStorage.getItem('randomBackground') || 1;
        let countLoop = 0;
        while(lastRandom === rndInt) {
          rndInt = Math.floor(Math.random() * maxBgIndex) + minBgIndex;
          countLoop++;
          if(countLoop === 6) break;
        }
        localStorage.setItem('randomBackground', rndInt);
      }catch{}
      return rndInt;
    }
  },
  mounted() {
    //let sliderPause = 6000;
    // $("#promotion-login-slider").bxSlider({
    //   mode: "fade",
    //   auto: true,
    //   pause: sliderPause,
    //   pager: false,
    //   randomStart: true,
    //   controls: false,
    // });

    // setInterval(() => {
    //   this.change = !this.change;
    // }, 15000);
  },
  created() {
    if (this.$route.name === "Register") {
      this.openComponentView("Register");
    }
    if (this.$route.name === "ForgotPassword") {
      this.openComponentView(this.$route.name);
    }
    this.getIpInfo();
  },
  methods: {
    openComponentView(componentName) {
      this.mainComponent = lazyLoadComponent({
        componentFactory: () =>
          import(`@/views/auth/component/${componentName}`),
        loading: SkeletonBox,
      });
      let urlParams = queryString.stringify(this.$route.query);

      if (componentName === "Register") {
        window.history.pushState("", "", `/register?${urlParams}`);
      }

      if (componentName === "ForgotPassword") {
        window.history.pushState("", "", "/forgot-password");
      }

      if (componentName === "Login") {
        window.history.pushState("", "", "/login");
      }
    },
    getIpInfo() {
      authApi
        .getIpInfo()
        .then((res) => {
          try {
            let data = res.data;
            if (data) {
              let ipDetails = JSON.parse(data);
              if (ipDetails.status === "success") {
                this.location = ipDetails.countryCode;
              }
            }
          } catch (error) {
            //this.$store.dispatch("common/showUnkownError", error, this.$lang.dialog.sendEmailFailed);
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("getIpInfo -> error", error);
        });
    },
  },
  watch: {
    overlay(val) {
      val &&
        setTimeout(() => {
          this.overlay = false;
        }, 3000);
    },
  },
};
</script>
